export default __webpack_public_path__ + "static/media/image22.f87f5fd4.png";